import { type Configuration, LogLevel } from '@azure/msal-browser';

const levelFromEnv = (import.meta.env.VITE_MSAL_LOG_LEVEL || 'Warning').toUpperCase();

const logLevelMap: Record<string, LogLevel> = {
  ERROR: LogLevel.Error,
  WARNING: LogLevel.Warning,
  WARN: LogLevel.Warning,
  INFO: LogLevel.Info,
  VERBOSE: LogLevel.Verbose,
};

const resolvedLevel = logLevelMap[levelFromEnv] ?? LogLevel.Warning;

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_POST_LOGOUT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: resolvedLevel,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
    allowRedirectInIframe: true,
  },
};
